// Module d'affichage d'image optimisée
import React from 'react';
import { OptimizedImage } from '../../G&CSCM/Core/OptimizedImage';

interface ImageModuleProps {
    fileId?: string;
    src?: string;
    alt?: string;
    quality?: number | string | null;  // 0-95% (number ou string, peut être vide pour auto-détection)
    width?: number | string | null;
    height?: number | string | null;
    loadOriginal?: boolean | string;  // Charger l'original après la qualité initiale
}

const ImageModule: React.FC<ImageModuleProps> = ({
    fileId,
    src,
    alt = 'Image',
    quality,
    width,
    height,
    loadOriginal
}) => {
    // Convertir quality en number si c'est une string (depuis API ou config)
    // Si vide (""), null, undefined, 0, ou invalide → auto-détection
    const qualityNumber = quality !== undefined && quality !== null && quality !== '' && quality !== 0
        ? (typeof quality === 'string' ? parseInt(quality, 10) : quality)
        : undefined;
    
    // Vérifier que c'est un nombre valide (>0), sinon undefined pour auto-détection
    const validQuality = qualityNumber !== undefined && !isNaN(qualityNumber) && qualityNumber >= 1 && qualityNumber <= 95
        ? qualityNumber
        : undefined;  // undefined = auto-détection
    
    // Convertir width (0 = vide = auto-détection)
    const widthNumber = width !== undefined && width !== null && width !== '' && width !== 0
        ? (typeof width === 'string' ? parseInt(width, 10) : width)
        : undefined;
    
    const validWidth = widthNumber !== undefined && !isNaN(widthNumber) && widthNumber > 0
        ? widthNumber
        : undefined;
    
    // Convertir height (0 = vide = auto)
    const heightNumber = height !== undefined && height !== null && height !== '' && height !== 0
        ? (typeof height === 'string' ? parseInt(height, 10) : height)
        : undefined;
    
    const validHeight = heightNumber !== undefined && !isNaN(heightNumber) && heightNumber > 0
        ? heightNumber
        : undefined;
    
    // Convertir loadOriginal
    const shouldLoadOriginal = loadOriginal === true || loadOriginal === 'true' || loadOriginal === undefined;

    // Log pour debug
    React.useEffect(() => {
        console.log('🎯 ImageModule configuré:', {
            fileId,
            src,
            quality: validQuality ?? 'AUTO',
            width: validWidth ?? 'AUTO',
            height: validHeight ?? 'AUTO',
            loadOriginal: shouldLoadOriginal
        });
    }, [fileId, src, validQuality, validWidth, validHeight, shouldLoadOriginal]);

    return (
        <div className="image-module" style={{ width: '100%', height: '100%' }}>
            <OptimizedImage
                fileId={fileId}
                src={src}
                alt={alt}
                quality={validQuality}  // Si undefined, détection automatique
                width={validWidth}
                height={validHeight}
                loadOriginal={shouldLoadOriginal}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default ImageModule;
